import React from 'react';

const InfoIconGray = ({ ...props }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="5" cy="5" r="5" fill="#D5D5D5" />
    <path
      d="M5.71192 3.57916H4.41763V8.04488H5.71192V3.57916ZM5.84906 2.20773C5.84906 1.71059 5.55763 1.42773 5.06906 1.42773C4.57192 1.42773 4.28906 1.71059 4.28906 2.20773C4.28906 2.70488 4.57192 2.99631 5.06906 2.99631C5.55763 2.99631 5.84906 2.70488 5.84906 2.20773Z"
      fill="white"
    />
  </svg>
);

export default InfoIconGray;
